import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD,
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID,

    ACTION_INSTITUTIONITEMTEMPLATE_SAVE,

    ACTION_INSTITUTIONITEMTEMPLATE_CREATE,

    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE,

    IInstitutionItemTemplateLoadAction,
    IInstitutionItemTemplateLoadByIdAction,
    IInstitutionItemTemplateLoadFailureAction,
    IInstitutionItemTemplateLoadSuccessAction,

    IInstitutionItemTemplateSaveAction,
    IInstitutionItemTemplateSaveSuccessAction,
    IInstitutionItemTemplateSaveFailureAction,

    IInstitutionItemTemplateCreateAction,
    IInstitutionItemTemplateCreateSuccessAction,
    IInstitutionItemTemplateCreateFailureAction,

    IInstitutionItemTemplateValidateAction,
    IInstitutionItemTemplateValidateSuccessAction,
    IInstitutionItemTemplateValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionItemTemplate";
import { institutionItemTemplatesApi } from "../services/institutionItemTemplates";


export const
    getInstitutionItemTemplatesEpic = (action$): Observable<IInstitutionItemTemplateLoadSuccessAction | IInstitutionItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMTEMPLATE_LOAD)
            .mergeMap((action: IInstitutionItemTemplateLoadAction) => {
                return institutionItemTemplatesApi
                    .getInstitutionItemTemplates(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionItemTemplates, response.institutionItemsByCategory, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionItemTemplatesByIdEpic = (action$): Observable<IInstitutionItemTemplateLoadSuccessAction | IInstitutionItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID)
            .mergeMap((action: IInstitutionItemTemplateLoadByIdAction) => {
                return institutionItemTemplatesApi
                    .getInstitutionItemTemplateById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionItemTemplate, undefined, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionItemTemplateEpic = (action$): Observable<IInstitutionItemTemplateSaveSuccessAction | IInstitutionItemTemplateSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMTEMPLATE_SAVE)
            .mergeMap((action: IInstitutionItemTemplateSaveAction) => {
                return institutionItemTemplatesApi
                    .setInstitutionItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionItemTemplateEpic = (action$): Observable<IInstitutionItemTemplateCreateSuccessAction | IInstitutionItemTemplateCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMTEMPLATE_CREATE)
            .mergeMap((action: IInstitutionItemTemplateCreateAction) => {
                return institutionItemTemplatesApi
                    .createInstitutionItemTemplate(action.institutionId)
                    .map(response =>
                        CreateSuccess(response.institutionItemTemplate, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionItemTemplateEpic = (action$): Observable<IInstitutionItemTemplateValidateSuccessAction | IInstitutionItemTemplateValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE)
            .mergeMap((action: IInstitutionItemTemplateValidateAction) => {
                return institutionItemTemplatesApi
                    .validateInstitutionItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }